/**
 * Utility for triggering a browser CSV file download from raw text content.
 *
 * @module downloadCsv
 */

/**
 * Triggers a browser download of a CSV string by creating a temporary
 * Blob object URL and clicking a hidden anchor element.
 *
 * @param csvContent - Raw CSV text to download
 * @param filename - Desired download filename (should end with `.csv`)
 */
export const downloadCsv = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
